import React, { useEffect, useContext, useState, createContext } from "react";
import { experimentalStyled as styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import { useNavigate } from "react-router-dom";

import IconRole from "../assets/icon-role.png";
import CareManager from "../assets/icon-care-manager.png";
import Patient from "../assets/icon-patient.png";
import Others from "../assets/icon-addOther.png";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import IconPatientImage from "../assets/icon-patient-photo.png";
import "./FixedHeader.css";

import IconFeedbackLeft from "../assets/icon-feedback1.png";
import IconFeedbackRight from "../assets/icon-feedback2.png";

import Icon_AddLovedOnes from "../assets/icon-add-loved-ones.png";
import IconPatientInfo from "../assets/icon-pnt-info.png";
import IconSetupCareRing from "../assets/icon-setup-care-ring.png";
import IconHealthReports from "../assets/icon-pReports.png";
import VitalsBloodPressure from "../assets/vitals-blood-pressure.png";
import VitalsPulseRate from "../assets/vitals-pulse-rate.png";
import VitalsOxygenSaturation from "../assets/vitals-oxygen-saturation.png";
import VitalsBloodSugar from "../assets/vitals-blood-sugar.png";
import VitalsBreathingRate from "../assets/vitals-breathing-rate.png";
import VitalsTemperature from "../assets/vitals-temperature.png";
import IconDailyCheckIn from "../assets/icon-daily-checkIn.png";
import IconVitalsSummary from "../assets/icon-vitals-summary.png";
import IconVitalsDashboard from "../assets/icon-vitals-dashboard.png";
import IconCManager from "../assets/icon-cmanager.png";
import IconCRConsent from "../assets/icon-care-rings-consent.png";
import IconAddCarerInfo from "../assets/icon-add-local-care-info.png";
import IconSymptoms from "../assets/icon-symptoms.png";
import IconSymNose from "../assets/icon-sym-rnose.png";
import IconSymCough from "../assets/icon-sym-cough.png";
import IconSymUrine from "../assets/icon-sym-urine.png";

import CarouselSlider from "../pages/CarouselSlider";
import { UserContext } from "../contexts/user.context";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function FixedHeader(props) {
  // console.log("props:", props);
  const navigate = useNavigate();
  const { user, pId, pName } = useContext(UserContext);

  const onBack = () => {
    const path = `/careManagerDetails`;
    navigate(path);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    navigate(-1);
  };
  const datex = new Date();

  let title = props.title;
  let title2 = props.title2;
  let title3 = "" + props.title3;
  let limg = "";
  let rimg = "";
  let pname = pName;

  if (props.limg == "rl") {
    // role page left image
    limg = IconPatientImage;
  } else if (props.limg == "fl") {
    // feedback page left image
    limg = IconFeedbackLeft;
  }

  if (props.rimg == "rr") {
    // role page right image
    rimg = IconRole;
  } else if (props.rimg == "fr") {
    // feedback page right image
    rimg = IconFeedbackRight;
    pname = "";
  } else if (props.rimg == "alr") {
    // AddLovdOnes page right image
    rimg = Icon_AddLovedOnes;
    pname = "";
  } else if (props.rimg == "ppr") {
    // Patient personal page right image
    rimg = IconPatientInfo;
  } else if (props.rimg == "scr") {
    // Setup care page right image
    rimg = IconSetupCareRing;
    // pname = "";
  } else if (props.rimg == "hrr") {
    // Health vault page right image
    rimg = IconHealthReports;
  } else if (props.rimg == "bpr") {
    // blood pressure page right image
    rimg = VitalsBloodPressure;
  } else if (props.rimg == "prr") {
    // pulse rate page right image
    rimg = VitalsPulseRate;
  } else if (props.rimg == "dcr") {
    // daily checkIn page right image
    rimg = IconDailyCheckIn;
  } else if (props.rimg == "vsr") {
    // vitals summary image
    rimg = IconVitalsDashboard;
  } else if (props.rimg == "adr") {
    // care manager image
    rimg = IconCManager;
  } else if (props.rimg == "osr") {
    // Oxygen Saturation image
    rimg = VitalsOxygenSaturation;
  } else if (props.rimg == "bsr") {
    // Blood Sugar image
    rimg = VitalsBloodSugar;
  } else if (props.rimg == "brr") {
    // Breathing Rate image
    rimg = VitalsBreathingRate;
  } else if (props.rimg == "tr") {
    // Breathing Rate image
    rimg = VitalsTemperature;
  } else if (props.rimg == "vs") {
    // Vitals summary image
    rimg = IconVitalsDashboard;
  } else if (props.rimg == "crc") {
    // Vitals summary image
    rimg = IconCRConsent;
  } else if (props.rimg == "adci") {
    // Vitals summary image
    rimg = IconAddCarerInfo;
  } else if (props.rimg == "sr") {
    // symptoms summary image
    rimg = IconSymptoms;
  } else if (props.rimg == "s-rnr") {
    // symptoms Nose image
    rimg = IconSymNose;
  } else if (props.rimg == "s-cur") {
    // symptoms Cough image
    rimg = IconSymCough;
  } else if (props.rimg == "s-ur") {
    // symptoms Cough image
    rimg = IconSymUrine;
  }

  return (
    <Card
      style={{
        // borderTop: "6px solid #1D5A90",
        borderRadius: "10px",
        padding: "20pt",
        background: "#F2F8F1",
        marginTop: "0rem",
        marginBottom: "1rem",
        maxWidth: "500px",
        position: "fixed",
        zIndex: "2",
      }}
    >
      <Box>
        <Grid
          container
          style={{
            maxWidth: "500px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            class="container"
            style={{ marginTop: "-1rem", marginBottom: "-1rem" }}
          >
            <div class="row">
              <div className="col-2" style={{ marginBottom: "0rem" }}>
                <ArrowBackIosIcon
                  // onClick={onBack}
                  onClick={onSubmit}
                  style={{
                    marginTop: "0rem",
                    cursor: "pointer",
                    marginBottom: "0rem",
                  }}
                />
              </div>
              <div className="col-8">
                <p
                  style={{
                    // fontSize: "1.5rem",
                    fontFamily: "Helvetica",
                    color: "#209F85",
                    marginBottom: "0pt",
                    marginTop: "-0.1rem",
                    textAlign: "center",
                  }}
                  className="title"
                >
                  {title}
                </p>
              </div>
            </div>
            <div class="row">
              <div className="col-2">
                <p
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    // marginTop: "0rem",
                    // marginBottom: "0rem",
                  }}
                  className="pnt-icon"
                >
                  <img
                    src={limg}
                    style={{
                      // alignItems: "center",
                      // display: "flex",
                      // justifyContent: "center",
                      // marginLeft: "-1rem",
                      marginTop: "0rem",
                      width: "150%",
                      height: "auto",
                      // maxWidth: "90px",
                      // minWidth: "45px",
                    }}
                  />
                </p>
                <p
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "0rem",
                    marginBottom: "0rem",
                    color: "#707070",
                    textAlign: "center",
                  }}
                  className="pnt-name"
                >
                  {pname}
                </p>
              </div>
              <div className="col-7">
                <p
                  style={{
                    // fontSize: "100%",
                    fontFamily: "Helvetica",
                    color: "#adaaa7",
                    marginBottom: "12pt",
                    marginTop: "0pt",
                    textAlign: "center",
                  }}
                  className="title2"
                >
                  {title2}
                </p>
              </div>
              <div className="col-3" style={{ marginTop: "0rem" }}>
                <img
                  src={rimg}
                  // style={{ width: "auto", minWidth: "30px", maxWidth: "90px" }}
                  style={{ width: "120%" }}
                />
              </div>
            </div>
            <div class="row">
              <p
                style={{
                  // fontSize: "100%",
                  fontFamily: "Helvetica",
                  color: "#adaaa7",
                  marginBottom: "0pt",
                  marginTop: "0.1pt",
                  textAlign: "center",
                }}
                className="title3"
              >
                Last Updated: {datex.toDateString()}
                {/* {title3} */}
              </p>
            </div>
          </div>
        </Grid>
      </Box>
    </Card>
  );
}
export default FixedHeader;
